import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './ImpactStories.css';
import { impactStories } from '../data/impactStories';

const ImpactStories = () => {
  const scrollRef = useRef(null);

  // Use first 5 stories for the carousel (adjust as needed)
  const stories = impactStories.slice(0, 5);

  const scrollByWidth = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = el.clientWidth; // scroll roughly one viewport of cards
    el.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };

  return (
    <section className="impact-stories">
      <div className="container">
        <div className="section-header">
          <span className="section-label">IMPACT STORIES</span>
          <h2 className="section-title">
            Real People. Real Stories.<br />Real Change
          </h2>
          <Link to="/impact-stories" className="view-all-link">
            View All Stories →
          </Link>
        </div>

        <div className="stories-carousel">
          <div className="carousel-container">
            <button
              type="button"
              className="carousel-btn prev"
              onClick={() => scrollByWidth(-1)}
              aria-label="Previous stories"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15 18L9 12L15 6V18Z"/>
              </svg>
            </button>
            
            <div className="stories-grid" ref={scrollRef}>
              {stories.map((story, index) => (
                <div key={index} className="story-card">
                  <div className="story-image">
                    <img src={story.image} alt={story.name} />
                    <div className="story-overlay">
                      <Link 
                        to={`/impact-story/${story.id}`} 
                        className="read-more-btn"
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              className="carousel-btn next"
              onClick={() => scrollByWidth(1)}
              aria-label="Next stories"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 18L15 12L9 6V18Z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactStories;
